import React from 'react'
import {ProfileImage} from '../../../components/ProfileImage'
import styles from './ImageSection.scss'
import { CLIENT_FORM } from 'src/constants/FormNames';
import { connect } from 'react-redux'
import { getFormValues, change as formChange } from 'redux-form'
import { withTranslation } from "react-i18next"
import {imageType} from "../../../utils/Form"
import {AddFile} from 'jbc-front/components/icons'

function CompanyImageSection({dispatch, logo, signature, t}) {
    const uploadLogo = async (data) => {	
        if (data !== undefined) {
            dispatch(formChange(CLIENT_FORM, "client.logo", data))
            dispatch(formChange(CLIENT_FORM, "clientLogo", null))
        }	
    }	

    const uploadSignature = async (data) => {
        if (data !== undefined) {
            dispatch(formChange(CLIENT_FORM, "client.signature", data))
            dispatch(formChange(CLIENT_FORM, "clientSignature", null))
        }
    }

    const removeLogo = () => {
        dispatch(formChange(CLIENT_FORM, "client.logo", null))
        dispatch(formChange(CLIENT_FORM, "clientLogo", null))
    }

    const removeSignature = () => {
        dispatch(formChange(CLIENT_FORM, "client.signature", null))
        dispatch(formChange(CLIENT_FORM, "clientSignature", null))
    }

    return (
        <div className={styles.imagesection}>
            <ProfileImage edit name="logo" label={t('features.Clients.components.ImageSection.client_logo')}
                          image={imageType(logo)} uploadImage={uploadLogo} defaultImage={<AddFile size={200} />} removeImage={removeLogo} />

            <ProfileImage edit name="signature" label={t('features.Clients.components.ImageSection.client_signature')}
                          image={imageType(signature)} uploadImage={uploadSignature} aspect={5} defaultImage={<AddFile size={200} />} removeImage={removeSignature} />

        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
    return({
        logo: getFormValues("client")(state) !== undefined ? getFormValues("client")(state).clientLogo || getFormValues("client")(state).client.logo : null,
        signature: getFormValues("client")(state) !== undefined ? getFormValues("client")(state).clientSignature || getFormValues("client")(state).client.signature : null,
})}

export default connect(mapStateToProps)(withTranslation()(CompanyImageSection))